import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIntelComponent } from './simple-icons-intel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIntelComponent ],
    exports:      [ SimpleIconsIntelComponent ],
    bootstrap:    []
})
export class SimpleIconsIntelModule {}
